var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    fill: "none",
    d: "M 20 30.882812 C 15.5 30.882812 10.660156 29.125 6 25.796875 C 2.515625 23.308594 0.367188 20.84375 0.277344 20.742188 C -0.09375 20.316406 -0.09375 19.683594 0.277344 19.257812 C 0.367188 19.15625 2.515625 16.691406 6 14.203125 C 10.660156 10.875 15.503906 9.117188 20 9.117188 C 24.5 9.117188 29.339844 10.875 34 14.203125 C 37.484375 16.691406 39.632812 19.15625 39.722656 19.257812 C 40.09375 19.683594 40.09375 20.316406 39.722656 20.742188 C 39.632812 20.84375 37.484375 23.308594 34 25.796875 C 29.339844 29.125 24.5 30.882812 20 30.882812 Z M 2.683594 20 C 3.550781 20.886719 5.191406 22.445312 7.359375 23.988281 C 10.332031 26.101562 14.933594 28.621094 20 28.621094 C 25.066406 28.621094 29.667969 26.101562 32.640625 23.988281 C 34.808594 22.445312 36.449219 20.886719 37.316406 20 C 36.449219 19.113281 34.808594 17.554688 32.640625 16.011719 C 29.667969 13.898438 25.066406 11.378906 20 11.378906 C 14.933594 11.378906 10.332031 13.898438 7.359375 16.011719 C 5.191406 17.554688 3.550781 19.113281 2.683594 20 Z M 2.683594 20 "
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    fill: "none",
    d: "M 20 27.011719 C 16.132812 27.011719 12.988281 23.867188 12.988281 20 C 12.988281 16.132812 16.132812 12.988281 20 12.988281 C 21.699219 12.988281 23.339844 13.605469 24.621094 14.722656 C 25.089844 15.136719 25.136719 15.851562 24.726562 16.320312 C 24.3125 16.789062 23.597656 16.835938 23.128906 16.425781 C 22.261719 15.667969 21.152344 15.25 20 15.25 C 17.378906 15.25 15.25 17.378906 15.25 20 C 15.25 22.621094 17.378906 24.75 20 24.75 C 22.621094 24.75 24.75 22.621094 24.75 20 C 24.75 19.375 25.257812 18.867188 25.882812 18.867188 C 26.507812 18.867188 27.011719 19.375 27.011719 20 C 27.011719 23.867188 23.867188 27.011719 20 27.011719 Z M 20 27.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    fill: "none",
    d: "M 20 22.261719 C 18.753906 22.261719 17.738281 21.246094 17.738281 20 C 17.738281 18.753906 18.753906 17.738281 20 17.738281 C 21.246094 17.738281 22.261719 18.753906 22.261719 20 C 22.261719 21.246094 21.246094 22.261719 20 22.261719 Z M 20 22.261719 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeon);
export default __webpack_public_path__ + "static/media/eyeon.0306a13b625906f2df55d860e011eb6f.svg";
export { ForwardRef as ReactComponent };